import React, {useEffect} from 'react';
import {notification} from 'antd';
import {AppLoader} from '../../../@ict';
import {useDispatch, useSelector} from 'react-redux';
import {hideMessage} from '../../../redux/actions';
import {useIntl} from 'react-intl';

const AppInfoView = () => {
  const {loading, error, displayMessage} = useSelector(({common}) => common);
  const dispatch = useDispatch();
  const {messages} = useIntl();

  useEffect(() => {
    if (error) {
      let content = messages[error];
      if (content == undefined) content = error;
      notification.error({
        description: content,
        style: {
          backgroundColor: '#FFF1F0',
          border: '1px solid #FFA39E',
        },
      });
      dispatch(hideMessage());
    }
  }, [error]);

  useEffect(() => {
    if (displayMessage) {
      let content = messages[displayMessage];
      if (content == undefined) content = displayMessage;
      notification.success({
        description: content,
        style: {
          background: '#F1FFFA',
          border: '1px solid #31C18D',
        },
      });
      dispatch(hideMessage());
    }
  }, [displayMessage]);

  return <>{loading ? <AppLoader /> : null}</>;
};

export default AppInfoView;
